<template>
  <!-- 公司招聘-->
  <section id="recruit">
    <div class="caption">
      <h2>公司招聘</h2>
      <span>CAREERS</span>
    </div>
    <div class="recruit">
      <div class="boards">
        <div class="board">
          <div class="img img-1"></div>
          <div class="body body-r">
            <span>人才理念</span>
            <p>崇尚“业绩导向”，倡导学习、创新、团队意识和价值创造。</p>
            <p>在公司营造公平竞争的内部环境，真正实现能者上、平者让、庸者下、劣者汰，为公司战略实施和持续发展提供坚强有力的人才支撑。</p>
          </div>
        </div>
        <div class="board">
          <div class="body body-l">
            <span>人力资源开发体系</span>
            <p>定位"高标准"</p>
            <p>倡导"高绩效"</p>
            <p>实施"高激励"</p>
            <p>助推"高成长"</p>
            <p>焕发"高激情"</p>
          </div>
          <div class="img img-2"></div>
        </div>
        <div class="board">
          <div class="img img-3"></div>
          <div class="body body-r">
            <span>人才培养</span>
            <p>坚持“服务战略、助力业务、全员培训、重点培养、以人为本、学以致用”的原则</p>
            <p>持续开展专业类、能力类等不同纬度培训</p>
            <p>不断提升人才专业化水平和科学管理能力</p>
          </div>
        </div>
      </div>

      <div class="positions">
        <div class="position" data-id="a1" @click="showPosition">
          <h1>二月 26，2020</h1>
          <span>北京 产品经理 10k-15k/月</span>
        </div>
        <div class="position" data-id="a2" @click="showPosition">
          <h1>二月 26，2020</h1>
          <span>北京 需求分析师 10k-15k/月</span>
        </div>
        <div class="position" data-id="a3" @click="showPosition">
          <h1>二月 26，2020</h1>
          <span>北京 行政人事经理 10k-15k/月</span>
        </div>
      </div>
    </div>

    <b-modal id="my-modal" title="【北京】行政人事经理" size="lg" scrollable hide-footer>
      <p>工作地点：北京市</p>
      <p>岗位职责：</p>
      <p>行政方面：</p>
      <p>负责全公司日常行政事务管理。</p>
      <p>负责公司来往信函的收发、登记、传阅、批示，及部门档案资料的归档立卷管理工作，做好公司原始资料收集和编纂工作。</p>
      <p>组织安排公司办公会议，或会同有关部门筹备公司其他会议及有关重要活动，做好会议记录和整理会议纪要，根据需要按会议决定发布文件。</p>
      <p>负责公司办公设施的管理。包括公司办公用品采购、发放、使用登记、保管、维护管理工作，负责传真机、复印机、长途电话、电脑的管理和使用。</p>
      <p>组织安排各种文体活动和旅游活动。</p>
      <p>完成上级交办的的其他事宜。</p>
      <p>人事方面：</p>
      <p>负责公司考勤表记录与管理工作。</p>
      <p>根据各部门特殊性来制定出绩效考核标准及考核工作。</p>
      <p>负责公司五险一金及社保相关事宜的办理工作。</p>
      <p>负责公司薪酬核算工作，包括社保、补助等在内的一系列基本项。</p>
      <p>负责公司物品的预算、采购、管理工作。</p>
      <p>设备的管理与登记工作，能够做到来源清晰，出处了然于心。</p>
      <p>参与制定各项制度，诸如考勤制度，资产管理制度，绩效考核制度，会议制度等。</p>
      <p>人事档案的管理工作与通讯录的更新工作。</p>
      <p>负责公司招聘和培训工作。</p>
      <p>公司的人员调配工作。</p>
    </b-modal>
  </section>
</template>

<script>
import Vue from "vue";
import { ModalPlugin } from "bootstrap-vue";

Vue.use(ModalPlugin);

export default {
  data() {
    return {
      showDialog: false
    };
  },
  methods: {
    showPosition: function(e) {
      // console.log(e.target.dataset.id);
      // this.$bvModal.show("my-modal");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";

.caption {
  // width: 40%;
  padding-bottom: 30px;
  text-align: center;

  > h1 {
    margin-bottom: 5px;
    font-weight: 500;
    font-size: 22px;
    text-align: center;
    color: #333333;
  }
}

section {
  /* 招聘 */
  &#recruit {
    margin-bottom: 30px;
    width: $SIZE_PAGE_WIDTH;

    > .recruit {
      display: flex;
      flex-direction: column;
      text-align: center;

      > .boards {
        display: flex;
        flex-direction: column;

        > .board {
          display: flex;
          margin-bottom: 20px;

          > .img {
            background-size: contain;
            flex-grow: 1;
            width: 30vw;
            height: 22vw;
          }

          > .img-1 {
            background: url(../../assets/images/aboutus/joinus1.png) no-repeat
              center;
            background-size: 100% 100%;
          }

          > .img-2 {
            background: url(../../assets/images/aboutus/joinus2.png) no-repeat
              center;
            background-size: 100% 100%;
          }

          > .img-3 {
            background: url(../../assets/images/aboutus/joinus3.png) no-repeat
              center;
            background-size: 100% 100%;
          }

          > .body {
            flex-grow: 1;
            width: 30vw;
            text-align: left;
            align-self: center;
            // transform: translateY(-10%);
            margin-top: -20px;

            > span {
              display: inline-block;
              color: $COLOR_card_title;
              font-size: $FONTSIZE_card_title;

              margin-bottom: 0.7em;
              line-height: 2em;
              border-bottom: 2px solid $COLOR_card_title;
            }

            > p {
              font-size: 0.8em;
              line-height: 20px;
            }
          }

          > .body-r {
            margin-left: 20px;
          }

          > .body-l {
            margin-right: -20px;
          }
        }
      }

      > .positions {
        display: flex;
        justify-content: space-between;
        margin: 40px 0;

        > .position {
          width: 16vw;
          height: 5vw;
          padding: 1.5vw;
          box-sizing: content-box;
          text-align: left;
          box-shadow: 0 2px 5px 0 rgba(80, 80, 80, 0.15);

          > h1 {
            line-height: 0.1rem;
            font-size: 0.08rem;
            font-weight: normal;
            margin-bottom: 0.1rem;
          }

          > span {
            line-height: 3vw;
            font-size: 0.8em;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>